import { render, staticRenderFns } from "./getBankTac.vue?vue&type=template&id=79fc96ce&lang=pug"
import script from "./getBankTac.vue?vue&type=script&lang=js"
export * from "./getBankTac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports